import moment from 'moment';
import { RootState } from '../store';
import { Message } from '../models/Message';

export const sortByCreatedDate = (a: Message, b: Message): number => moment(b.createdDate).diff(a.createdDate);
export const selectMessages = (state: RootState): Array<Message> => state.messages.slice().sort(sortByCreatedDate);
export const selectUnreadMessageCount = (state: RootState): number => state.messages.filter(m => m.isRead !== true).length;
